import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { data } from 'jquery';
import { Notification } from '../../../core/Notifications/Notification';
import { ProfileService } from './profile.service';
import { FormBuilder, FormControlName } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root' 
})
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  user_profile: FormGroup;

  profile:any;
  pR_Photo;
  pR_FirstName;
  pR_LastName;
  pR_Email;
  pR_MobileNumber;
  pR_Gender;
  pR_DOB;
  pR_Age;
  pR_BloodGroup;
  pR_Village;
  pR_Taluk;
  pR_District;
  pR_StateName;
  pR_Country_Name;
  pR_Postalcode;
  Image_Url;
  NA_Country_Name;

  constructor(private profileservice: ProfileService, private router: Router, private formBuilder: FormBuilder,
    private notify: Notification,private fb: FormBuilder) {
      this.user_profile = this.fb.group({
        'email':[],
        'mobile_number':[],
        'gender':[],
        'dob':[],
        'age':[],
        'bloodgroup':[],
        'country':[],
        'state':[],
        'district':[],
        'taluk':[],
        'village':[],
        'postal_code':[]
       
    })
  }

  patient_id: any;
  ngOnInit(): void {   
    this.profileservice.get_Patientprofile()
    .subscribe((data:any) => {
      console.log('Patient profile:', data);
      this.patient_id=data.Id
      //alert(this.patient_id)
      localStorage.setItem('patient id', this.patient_id);
      
      this.pR_FirstName = data.Firstname
      this.pR_LastName = data.Lastname
      this.pR_Email = data.Email
      this.pR_MobileNumber = data.Mobilenumber
      this.pR_Gender = data.Gender
      if(data.DOB=="1900-01-01T00:00:00")
        this.pR_DOB=''
      else
      this.pR_DOB = data.DOB
  
      this.pR_Age = data.Age
      this.pR_BloodGroup = data.Bloodgroup
      this.pR_Village = data.Gram_name
      this.pR_Taluk = data.Taluk_name == "MDNA" ? '' : data.Taluk_name
      this.pR_District = data.District_name == "MDNA" ? '' : data.District_name
      this.pR_StateName = data.State_name == "MDNA" ? '' : data.State_name
      this.pR_Country_Name = data.Country_name
      this.pR_Postalcode = data.Postalcode
      this.Image_Url = data.Photo;
    })
    
    this.disableCtrls();
  }

  disableCtrls()
  {
    this.user_profile.controls['email'].disable();
    this.user_profile.controls['mobile_number'].disable();
    this.user_profile.controls['gender'].disable();
    this.user_profile.controls['dob'].disable();
    this.user_profile.controls['age'].disable();
    this.user_profile.controls['bloodgroup'].disable();
    this.user_profile.controls['country'].disable();
    this.user_profile.controls['state'].disable();
    this.user_profile.controls['district'].disable();
    this.user_profile.controls['taluk'].disable();
    this.user_profile.controls['village'].disable();
    this.user_profile.controls['postal_code'].disable();
  }
}